<template>
  <div class="container-stream">
    <div class="img active" :style="{
      backgroundImage: 'url(' + active.url + '?' + Math.floor(Math.random() * 10000) + ')',
      top: (active.top || 0),
      left: (active.left || 0),
      right: (active.right || 0),
      bottom: (active.bottom || 0)
    }" ></div>
    <div class="noise"></div>
  </div>
</template>

<script>
export default {
  name: 'Stream',
  props: {
    images: {
      type: Array,
      default: () => [ ]
    }
  },
  data () {
    return {
      active: { },
      next: { }
    }
  },
  mounted () {
    this.setImage()
    this.frame = setInterval(this.setImage, 60 * 1000)
  },
  beforeDestroy () {
    clearInterval(this.frame)
  },
  methods: {
    setImage () {
      const now = new Date().getMinutes()
      const active = mod(now, this.images.length)
      this.active = this.images[active] 
    } 
  }
}

function mod (num, mod) {
  let remain = num % mod
  return Math.floor(remain >= 0 ? remain : remain + mod)
}
</script>

<style scoped>
.container-stream {
  position: relative;
  height: 100%;
  width: 100%;
}

.img {
  position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform-origin: center;
  animation: scale 60s ease-in-out both;
  opacity: 0.9;
}

.noise {
  background-image: url('~@/assets/images/noise.gif');
  background-repeat: repeat;
  background-position: center;
  background-size: 300px 300px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.08;
}
</style>
